/**
 * Extracts template variables from a string containing {{variable}} syntax
 * @param template - The template string to parse
 * @returns Array of variable names found in the template
 */
export function extractTemplateVars(template: string): string[] {
  // Match anything between {{ and }}
  const regex = /\{\{([^}]+)\}\}/g;
  const matches: string[] = [];
  let match;

  while ((match = regex.exec(template)) !== null) {
    matches.push(match[1].trim());
  }

  return matches;
}
